module.exports = __webpack_public_path__ + "img/big_1_56.82bcdbba.png";